import { createFileRoute } from "@tanstack/react-router";
import StoryExperience from "@/components/StoryExperience";
import bannerPoster from "@/assets/banner-poster.webp.asset.json";

const URL = "https://www.travelbackland.com/";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "Backland — Luxury Nature Resort, Arizona" },
      { name: "description", content: "Rediscover each other, stillness, dark skies, and luxury at Backland — a luxury nature resort in Arizona." },
      { property: "og:title", content: "Backland — Luxury Nature Resort, Arizona" },
      { property: "og:description", content: "Rediscover each other. Rediscover nature. Rediscover luxury." },
      { property: "og:url", content: URL },
    ],
    links: [
      { rel: "canonical", href: URL },
      { rel: "preload", as: "image", href: bannerPoster.url, fetchPriority: "high", type: "image/webp" } as any,
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LodgingBusiness",
          name: "Backland",
          description:
            "Backland Luxury Nature Resort. Disconnect from the noise and reconnect to what matters most. Unique suites on 160 acres surrounded by national forest.",
          url: URL,
          address: {
            "@type": "PostalAddress",
            addressLocality: "Williams",
            addressRegion: "AZ",
            addressCountry: "US",
          },
        }),
      },
    ],
  }),
  component: Index,
});

function Index() {
  return (
    <>
      <StoryExperience />
    </>
  );
}
